import * as t from 'io-ts'

export const MetadataDescriptionCodec = t.strict({
    content: t.string,
    lockVersion: t.number,
})

export interface MetadataDescription extends t.TypeOf<typeof MetadataDescriptionCodec> {}
